export const CREATE_REMINDER = "CREATE_REMINDER";
export const UPDATE_REMINDER = "UPDATE_REMINDER";
export const DELETE_REMINDER = "DELETE_REMINDER";
export const FETCH_REMINDERS = "FETCH_REMINDERS";
